import { DateTime } from "luxon";
import { DEFAULT_TIMEZONE } from "@/lib/constants";

export function isNewTeenWindow(
  startedAt: string | number,
  now: DateTime = DateTime.now(),
): boolean {
  const start =
    typeof startedAt === "number"
      ? DateTime.fromMillis(startedAt, { zone: DEFAULT_TIMEZONE })
      : DateTime.fromISO(startedAt, { zone: DEFAULT_TIMEZONE });
  if (!start.isValid) {
    return false;
  }

  const days = now
    .setZone(DEFAULT_TIMEZONE)
    .startOf("day")
    .diff(start.startOf("day"), "days").days;

  return days >= 0 && days < 7;
}
